const getters = {
    sidebar: state => state.app.sidebar,
    size: state => state.app.size,
    device: state => state.app.device,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    token: state => state.user.token,
    type: state => state.user.type,
    userid: state => state.user.userid,
    avatar: state => state.user.avatar,
    plan_id: state => state.user.plan_id,
    form_id: state => state.user.form_id,
    institution_id: state => state.user.institution_id,
    institution: state => state.user.institution,
    username: state => state.user.username,
    nickname: state => state.user.nickname,
    mobile: state => state.user.mobile,
    department: state => state.user.department,
    department_id: state => state.user.department_id,
    name: state => state.user.name,
    introduction: state => state.user.introduction,
    roles: state => state.user.roles,
    show_logo: state => state.user.show_logo,
    permission_routes: state => state.permission.routes,
    errorLogs: state => state.errorLog.logs,
    qiniuToken: state => state.qiniu.Token,
    admin_menu_paths: state => state.user.admin_menu_paths,
    admin_role_ids: state => state.user.admin_role_ids,
    modal: state => state.user.modal,
    buyer_id: state => state.user.buyer_id,
}
export default getters